import React from "react";
import { useTable, useSortBy } from "react-table";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Button } from "react-bootstrap";
import useFetch from "../fetch";
import { UpArrow, DownArrow, DefaultArrow } from "../sortArrows";

const DocumentTable = () => {
  const state = useSelector((state) => {
    return {
      documents: state.documents,
      action: state.ui.action,
      organizationName: state.organization.name,
      resident: state.resident,
      permissions: state.current_user.permissions
    }
  });
  const dispatch = useDispatch();
  const fetch = useFetch();

  const columns = React.useMemo(() => [
    {
      Header: "Name",
      id: "name",
      accessor: (row) => row.name.toLowerCase(),
      Cell: ({ cell: { row: { original } } }) => (
        <a href={original.asset_url} target="_blank">{original.name}</a>
      )
    }, {
      Header: "Created at",
      id: "created_at",
      accessor: (row) => moment(row.created_at).toDate(),
      Cell: ({ cell: { row: { original: { created_at } } } }) => moment(created_at).format("lll")
    }
  ], [state.documents])

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: state.documents.documents
  }, useSortBy);
  const deleteDocument = (doc) => {
    const { organizationName, resident } = state;
    fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      data: {
        resident: {
          documents_attributes: [{
            id: doc.id,
            _destroy: true
          }]
        }
      }
    }).then(() => {
      dispatch({ type: "DELETE_DOCUMENT", payload: { document: doc } });
    });
  }

  return (
    <table {...getTableProps()} className="table table-responsive">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                <span>
                  {column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow />}
                </span>
              </th>
            ))}
            <th />
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
                <td>
                  {
                    state.action === "edit" && state.permissions.includes('Delete') &&
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={(e) => {
                        e.preventDefault();
                        deleteDocument(row.original);
                      }}>
                      Delete
                    </Button>
                  }
                </td>
              </tr>
            )
        )}
      </tbody>
    </table>
  )
}

export default DocumentTable;
